import { isIntentYes } from '@myap/metadata'
import { manipulateMinutes, isDateTimePast, formatDate } from '@myap/ui-library'
import Exam from './Exam'

import styles from './enrollment.module.scss'

const EnrollmentStatus = ({ digitalApplicable, id, ...props }) => {
  const { examStartTime, examEndTime } = props
  const examStartWithoutTime = formatDate(examStartTime)
  const checkinAvailableDate = manipulateMinutes(examStartTime, -30)
  const isCheckinAvailable = isDateTimePast(checkinAvailableDate)

  return (
    <div
      className={`${styles['status-container']} ${
        digitalApplicable ? styles['status-digital'] : ''
      }`}
      id={id}
    >
      <Exam
        {...props}
        isCheckinAvailable={isCheckinAvailable}
        checkinAvailableDate={checkinAvailableDate}
      />
    </div>
  )
}

export default EnrollmentStatus
